import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthenticationProvider";

// This component works like ProtectedRoute but checks for enabled features
const FeatureRoute = ({
  feature,
  featureCombo,
  children,
  fallbackPath = "/",
}) => {
  const { checkFeature, isLoading, organizationLoaded } = useAuth();

  // If still loading auth state, render nothing yet
  if (isLoading || !organizationLoaded) {
    return null;
  }

  // Handle feature combinations (e.g., uaRecording AND uaScheduling for UA page)
  if (featureCombo) {
    // featureCombo is an array of features with a required logical operation
    const { features, operator } = featureCombo;

    if (operator === "OR") {
      // If ANY feature is enabled, allow access
      const anyEnabled = features.some((f) => checkFeature(f));
      if (!anyEnabled) {
        return <Navigate to={fallbackPath} replace />;
      }
    } else if (operator === "AND") {
      // If ALL features are disabled, block access
      const allDisabled = features.every((f) => !checkFeature(f));
      if (allDisabled) {
        return <Navigate to={fallbackPath} replace />;
      }
    }
  }
  // Simple single feature check
  else if (feature && !checkFeature(feature)) {
    return <Navigate to={fallbackPath} replace />;
  }

  // Feature is enabled, render the children
  return children;
};

export default FeatureRoute;
